
import style from './style.scss';

import { h, Component } from 'preact';
import { route } from 'preact-router';

import TopBar from '../../../components/topbar';
import Form from '../../../components/form';

export default class EditPayment extends Component {
	onFinish = () => route('/');

	render({ firebaseId }, { payments }) {
		return (
			<section>
				<TopBar {...this.props} />

				<div class={`${style.payment_edit} page`}>
					<Form onFinish={this.onFinish} firebaseId={firebaseId} {...this.props} />
				</div>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./routes/payments/edit/index.js